module.exports = __webpack_public_path__ + "img/contact.a3c209d7.jpg";